module.exports = __webpack_public_path__ + "media/images/lp_modal-image_support-7aae5dc1be19c4b0d631709ccd4db719.webp";